import type { FormItem } from 'form/types';

const step: FormItem[] = [
  {
    type: 'checkbox',
    id: 'visitor-limit',
    label:
      'My site will have no more 20 workers per hectare if my crib rooms have best practice approaches including ventilation and density limits'
  },
  {
    type: 'checkbox',
    id: 'workforce-cap',
    label:
      'Any crib room on site will follow the best practice ventilation guidelines including density limit of 1 per person per 4sqm; and additional ventilation so that entire air volume of the room is replaced or filtered every 10 to 12 minutes.'
  },
  {
    type: 'checkbox',
    id: 'marshal',
    label:
      'I understand my COVID Marshal may be a site supervisor or site manager performing the role across multiple sites'
  }
];

export default step;
